document.addEventListener("DOMContentLoaded", function () {

    const button = document.getElementById("LoadMore");

    if (!button) return;

    button.addEventListener("click", async function () {

        const nextUrl = this.dataset.nextUrl;

        if (!nextUrl) return;

        this.disabled = true;

        this.innerHTML = "Loading...";

        try {

            const response = await fetch(nextUrl);

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(html, "text/html");

            const newProducts = doc.querySelector("#CollectionProductGrid");

            document
                .querySelector("#CollectionProductGrid")
                .insertAdjacentHTML(
                    "beforeend",
                    newProducts.innerHTML
                );

            const newButton = doc.querySelector("#LoadMore");

            if (newButton) {

                this.dataset.nextUrl =
                    newButton.dataset.nextUrl;

                this.disabled = false;

                this.innerHTML = "Load More";

            } else {

                this.remove();

            }

        } catch (error) {

            console.error(error);

            this.disabled = false;

            this.innerHTML = "Load More";

        }

    });

  });